import React, { FC } from 'react';
import { ReactComponent as Document } from '../../../assets/Common/Document.svg';

export const DocumentIcon: FC = () => <Document />;
